function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Form, Input, Button, Alert, Space, message } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { CheckCircle } from 'react-bootstrap-icons';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RecoverPassword = function RecoverPassword() {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    tokenFound = _useState6[0],
    setTokenFound = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    passwordChanged = _useState8[0],
    setPasswordChanged = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isFormProcessing = _useState10[0],
    setIsFormProcessing = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    token = _useState12[0],
    setToken = _useState12[1];
  var _useParams = useParams(),
    mobile = _useParams.mobile;
  var onFinishCode = function onFinishCode(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + 'verifypltoken', {
      mobile: mobile,
      token: values.token
    }).then(function (response) {
      if (response.data.status == 200) {
        setToken(response.data.token);
        setTokenFound(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  var onFinishReset = function onFinishReset(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + 'resetpassword', {
      mobile: mobile,
      token: token,
      password: values.password,
      password_confirmation: values.password_confirmation
    }).then(function (response) {
      if (response.data.status == 200) {
        setPasswordChanged(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "page-container",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [tokenFound == false && passwordChanged == false && /*#__PURE__*/_jsx("div", {
              className: "centeredBox",
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsxs("p", {
                  className: "yellowTipBox",
                  children: ["Un code vous \xE0 \xE9t\xE9 envoy\xE9 au ", /*#__PURE__*/_jsx("b", {
                    children: mobile
                  }), " ,  veuillez le saisir ici !"]
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
                  size: "large",
                  onFinish: onFinishCode,
                  layout: "vertical",
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "token",
                    rules: [{
                      required: true,
                      message: 'Veuillez entrer le code'
                    }],
                    children: /*#__PURE__*/_jsx(Input, {
                      placeholder: "Code"
                    })
                  }), errorMessage.length > 0 && /*#__PURE__*/_jsx("p", {
                    children: /*#__PURE__*/_jsx(Alert, {
                      type: "error",
                      message: errorMessage,
                      banner: true
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: isFormProcessing,
                      type: "primary",
                      htmlType: "primary",
                      children: "Verifier"
                    })
                  })]
                })]
              })
            }), tokenFound == true && passwordChanged == false && /*#__PURE__*/_jsx("div", {
              className: "centeredBox",
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx("p", {
                  children: "Veuillez saisir un nouveau mot de passe"
                }), /*#__PURE__*/_jsxs(Form, {
                  size: "large",
                  onFinish: onFinishReset,
                  layout: "vertical",
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "password",
                    rules: [{
                      required: true,
                      message: 'Veuillez entrer le nouveau mot de passe'
                    }],
                    children: /*#__PURE__*/_jsx(Input.Password, {
                      placeholder: "Mot de passe"
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "password_confirmation",
                    rules: [{
                      required: true,
                      message: 'Veuillez confirmer le le nouveau mot de passe'
                    }],
                    children: /*#__PURE__*/_jsx(Input.Password, {
                      placeholder: "Mot de passe de confirmation"
                    })
                  }), errorMessage.length > 0 && /*#__PURE__*/_jsx("p", {
                    children: /*#__PURE__*/_jsx(Alert, {
                      type: "error",
                      message: errorMessage,
                      banner: true
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: isFormProcessing,
                      type: "primary",
                      htmlType: "primary",
                      children: "Valider"
                    })
                  })]
                })]
              })
            }), tokenFound == true && passwordChanged == true && /*#__PURE__*/_jsx("div", {
              className: "centeredBox",
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx(CheckCircle, {
                  size: 90
                }), /*#__PURE__*/_jsx("p", {
                  children: "Mot de passe modifi\xE9 avec succ\xE8s !"
                }), /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  href: "/#/ok",
                  children: "Continuer"
                })]
              })
            })]
          })
        })
      })
    })
  });
};
export default RecoverPassword;